export const QUERY_PARAM = {
  FROM: "from",
  AMOUNT: "amount",
};

export const DEFAULT_QUERY_PARAM = {
  FROM: 0,
  AMOUNT: 10,
};
